import startCase from 'lodash/startCase'
import { ArkActionTypes } from '../../../../../actions/dashboards/Ark'
import { Metrics } from '../../../../../constants/Dashboards'
import { getColor } from '../../../../../containers/Dashboard/reduxIntegration/getReducer/colors'
import buildAsyncStatReducer from '../../asyncStatReducer'

type ButtonsPayload = {
    type: string
    button: string
    count: number
}[]

type ButtonsCount = {
    [buttonLabel: string]: number[]
}

type ButtonsState = {
    values: ButtonsCount
    labels: string[]
    total: number
    perc: null
    colors: string[]
}

/**
 * Ark Dwell Time per Sku reducer
 */
const arkButtons = buildAsyncStatReducer<ButtonsPayload, ButtonsState>({
    key: Metrics.ARK_BUTTONS,
    types: {
        request: ArkActionTypes.DASHBOARD_ARK_BUTTONS.request,
        success: ArkActionTypes.DASHBOARD_ARK_BUTTONS.success,
        failure: ArkActionTypes.DASHBOARD_ARK_BUTTONS.failure,
    },
    transform: (state, { payload }): ButtonsState => {
        let total = 0
        const colors: string[] = []

        const buttons: ButtonsCount = payload
            .sort(({ count: countA }, { count: countB }) => countA - countB)
            .reduce((out, row): ButtonsCount => {
                const { type = '', button = '', count } = row
                const buttonLabel = startCase(`${type} ${button ?? ''}`)
                colors.push(getColor(type))

                total += count
                return { ...out, [buttonLabel]: [count] }
            }, {})

        return {
            values: buttons,
            labels: [''],
            total,
            perc: null,
            colors,
        }
    },
})

export default arkButtons
